import { computed } from 'vue';
import { useAccount } from 'dashboard/composables/useAccount';
import { FEATURE_FLAGS } from 'dashboard/featureFlags';

// Disable campaign controls if account availability changes while a form is open.
export function useCampaignAvailability() {
  const { currentAccount } = useAccount();
  const campaignsEnabled = computed(
    () => !!currentAccount.value?.features?.[FEATURE_FLAGS.CAMPAIGNS]
  );
  return { campaignsEnabled };
}
